import { render, staticRenderFns } from "./v-searchable-select-shallow.vue?vue&type=template&id=80f68afe&scoped=true&"
import script from "./v-searchable-select-shallow.vue?vue&type=script&lang=js&"
export * from "./v-searchable-select-shallow.vue?vue&type=script&lang=js&"
import style0 from "./v-searchable-select-shallow.vue?vue&type=style&index=0&id=80f68afe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f68afe",
  null
  
)

export default component.exports